export default "/checked.f0acdd9577eabfd24ba6502968a69de1.svg";